import React from "react";
import { ActionHandlerFunction, AdminUserBase } from "@preveil-api";
import { AdminUIActionTypes, useAppSelector } from "src/common";
import { Icon, ToolbarWrapper, ToolbarFilter, ToolbarButton } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  is_loading: boolean;
  filter_param: string;
  user_list: AdminUserBase[];
  filtered_list: AdminUserBase[];
  org_users: AdminUserBase[];
  handleAction: ActionHandlerFunction;
}

function ToolbarComponent(props: AllProps) {
  const { filter_param, user_list, is_loading, filtered_list, org_users, handleAction } = props;
  const selected = useAppSelector((state: RootState) => state.admin.selected);
  const add_exception_user_tooltip = org_users.length === user_list.length ? "All users in your organization have been added to the exception list." : "Add Exception User";

  return <ToolbarWrapper
    leftContent={<ToolbarFilter
      disabled={user_list.length === 0}
      filter_param={filter_param}
      onChange={(value) => handleAction({ actionType: AdminUIActionTypes.SearchParam, params: value })}
      onClick={() => handleAction({ actionType: AdminUIActionTypes.SearchParam })} />}
    refreshAction={() => handleAction({ actionType: AdminUIActionTypes.GetRefreshRequest })}
    refreshTooltipContent="Refresh Users"
    isLoading={is_loading}
    paginationInfo={user_list.length > 0 ? <span>{`${filtered_list.length !== user_list.length ? `${filtered_list.length} of ` : ""} ${user_list.length} ${user_list.length > 1 ? "Users" : "User"}`}</span> : undefined}
  >
    <ToolbarButton
      onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}
      disabled={org_users.length === user_list.length}
      ariaLabel="Add Exception User"
      tooltipContent={add_exception_user_tooltip}>
      <Icon className="ficon-plus" />
    </ToolbarButton>
    <ToolbarButton
      onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete })}
      disabled={selected.length === 0}
      ariaLabel="Delete Selected"
      tooltipContent="Delete Selected">
      <Icon className="ficon-trash-2" />
    </ToolbarButton>
  </ToolbarWrapper>;
}

export default React.memo(ToolbarComponent);
